import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import Card from '../components/card'
import Footer from '../components/footer'
import './concept.css'

const Concept = (props) => {
  return (
    <div className="concept-container">
      <Helmet>
        <title>Concept - BharatKarade</title>
        <meta
          name="description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta property="og:title" content="Concept - BharatKarade" />
        <meta
          property="og:description"
          content="Hii i'm Bharat Karade, i have over 11+ years of experience in Game UI Design and graphic designs 2D in-depth knowledge of Drawing."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/37270ff6-c20f-4c60-89cf-ed199b10be0f/dec54fbc-2bef-42e2-a2f0-7c793b6d3599?org_if_sml=1"
        />
      </Helmet>
      <Header rootClassName="header-root-class-name4"></Header>
      <section className="concept-container1 Fade_in_up1">
        <span className="concept-text">
          <span>Concept Arts</span>
          <br></br>
        </span>
        <div id="Grider" className="concept-container2">
          <a
            href="https://iili.io/HVxUa6X.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUa6X.png"
              Image_name="game intro concept02"
              image_name="game intro concept02"
              rootClassName="card-root-class-name10"
              className="concept-component01"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUYGt.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUYGt.jpg"
              Image_name="jumping koko bg"
              image_name="jumping koko bg"
              rootClassName="card-root-class-name21"
              className="concept-component02"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxURZN.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxURZN.jpg"
              Image_name="mugal battale slice"
              image_name="mugal battale slice"
              rootClassName="card-root-class-name22"
              className="concept-component03"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxU0as.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxU0as.png"
              Image_name="scene02"
              image_name="scene02"
              rootClassName="card-root-class-name24"
              className="concept-component04"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUG9f.png"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUG9f.png"
              Image_name="scene03"
              image_name="scene03"
              rootClassName="card-root-class-name25"
              className="concept-component05"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUlFn.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUlFn.jpg"
              Image_name="mansing clouseup"
              image_name="mansing clouseup"
              rootClassName="card-root-class-name26"
              className="concept-component06"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUMu4.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUMu4.jpg"
              Image_name="1660038024787"
              image_name="1660038024787"
              rootClassName="card-root-class-name28"
              className="concept-component07"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUhnS.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUhnS.jpg"
              Image_name="Backgraound"
              image_name="Backgraound"
              rootClassName="card-root-class-name30"
              className="concept-component08"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUWt2.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUWt2.jpg"
              Image_name="bharat karade 01"
              image_name="bharat karade 01"
              rootClassName="card-root-class-name66"
              className="concept-component09"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUwP9.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUwP9.jpg"
              Image_name="bharat karade 02 (1)"
              image_name="bharat karade 02 (1)"
              rootClassName="card-root-class-name65"
              className="concept-component10"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUjM7.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUjM7.jpg"
              Image_name="bharat karade 02"
              image_name="bharat karade 02"
              rootClassName="card-root-class-name64"
              className="concept-component11"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUOFe.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUOFe.jpg"
              Image_name="bharat karade 03"
              image_name="bharat karade 03"
              rootClassName="card-root-class-name63"
              className="concept-component12"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUecu.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUecu.jpg"
              Image_name="bharat karade 04"
              image_name="bharat karade 04"
              rootClassName="card-root-class-name62"
              className="concept-component13"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUk8b.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUk8b.jpg"
              Image_name="bharat karade 04ec8622419459 563126b095623"
              image_name="bharat karade 04ec8622419459 563126b095623"
              rootClassName="card-root-class-name61"
              className="concept-component14"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxU89j.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxU89j.jpg"
              Image_name="bharat karade 05"
              image_name="bharat karade 05"
              rootClassName="card-root-class-name60"
              className="concept-component15"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUSAx.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUSAx.jpg"
              Image_name="bharat karade 06"
              image_name="bharat karade 06"
              rootClassName="card-root-class-name59"
              className="concept-component16"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUUwQ.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              Image_name="bharat karade 07 (1)"
              image_name="bharat karade 07 (1)"
              rootClassName="card-root-class-name58"
              image_url="https://iili.io/HVxUUwQ.jpg"
              className="concept-component17"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUgtV.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUgtV.jpg"
              Image_name="bharat karade 10513251 675849549162270 3677189195679298159 n (1)"
              image_name="bharat karade 10513251 675849549162270 3677189195679298159 n (1)"
              rootClassName="card-root-class-name57"
              className="concept-component18"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxU4oB.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxU4oB.jpg"
              Image_name="bharat karade banner (1)"
              image_name="bharat karade banner (1)"
              rootClassName="card-root-class-name56"
              className="concept-component19"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxU6MP.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxU6MP.jpg"
              Image_name="bharat karade cup"
              image_name="bharat karade cup"
              rootClassName="card-root-class-name55"
              className="concept-component20"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUsKF.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUsKF.jpg"
              Image_name="bharat karade treee (1)"
              image_name="bharat karade treee (1)"
              rootClassName="card-root-class-name54"
              className="concept-component21"
            ></Card>
          </a>
          <a
            href="https://iili.io/HVxUPP1.jpg"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Card
              image_url="https://iili.io/HVxUPP1.jpg"
              Image_name="for client"
              image_name="for client"
              rootClassName="card-root-class-name53"
              className="concept-component22"
            ></Card>
          </a>
        </div>
      </section>
      <Footer rootClassName="footer-root-class-name4"></Footer>
    </div>
  )
}

export default Concept
